import { ActivatedRoute, Router } from '@angular/router';
import { MarianomGeneral } from '../marianom-general.service';
import { MyNavigator } from './navegador-class';

export class PCNavigator extends MyNavigator {

    constructor(private router: Router, private serv: MarianomGeneral) {
        super();
    }
    goDetallePedido(router: ActivatedRoute) {
        this.router.navigate(['/detallepedido'], { relativeTo: router });
    }
    primerArticulo() {

        this.serv.opArtConModal();
    }
    precierreCheckout(router: ActivatedRoute) {
        this.router.navigate(['/checkout'], { relativeTo: router });
    }
    notLogin() {
        this.router.navigateByUrl('');
        this.serv.abrirModalLogin()
    }
    goHistorial(router: ActivatedRoute) {
        this.router.navigate(['/historial'], { relativeTo: router });
    }
    endline(router: ActivatedRoute) {
        this.router.navigate(['/checkout/finalizado'], { relativeTo: router });
    }
    cierreCheckout(router: ActivatedRoute) {
        this.router.navigate(['/checkout/finalizar'], { relativeTo: router });

    }

    goResetPass(router: ActivatedRoute) {
        this.router.navigate(['ayuda/resetpassword'], { relativeTo: router });
    }
    goCrearAccount(router: ActivatedRoute) {
        this.router.navigate(['ayuda/crearcuenta'], { relativeTo: router });
    }
    goSearch(router: ActivatedRoute) {
        this.router.navigate(['/busqueda'], { relativeTo: router });
    }

    goLandPage(router: ActivatedRoute) {
        this.router.navigate(['/'], { relativeTo: router });
    }

    irResumenCompra(router: ActivatedRoute) {
        this.router.navigate(['/resumendecompra'], { relativeTo: router });
    }

}
